import { fetchData, getData } from "../firebase/firebase_methods";

export const fetchBlogData = async (path) => {
  const dataRef = fetchData(path);
  const snapshot = await getData(dataRef);
  return snapshot.exists() ? snapshot.val() : null;
};
